export default __webpack_public_path__ + "static/media/virtual-bg16.6882b36a.png";